export default __webpack_public_path__ + "static/soharport-468cc7caf63878dbf43f07ef26fe68b0.jpg";